export function isChunkLoadError(error: Error): boolean {
  return error.name === 'ChunkLoadError' || Boolean(error.message?.startsWith('Loading chunk'))
}
